import {
  ADD_IMAGE_TO_TRANSACTION,
  ADD_PETTY_CASH,
  ADD_PROJECT,
  ADD_TRANSACTION,
  GET_ACCOUNTANT,
  GET_EXCEL,
  GET_PDF,
  HASHTAG_REPORT,
  MONTHLY_REPORT,
  ADD_MONTHLY_BUDGET,
  ADD_PETTY_CASH_BUDGET,
  PRINT_SUMMARY_PAYMENT_RECEIVE,
  COPY_TRANSACTION,
  SHARE_USER,
  CONTACT_REPORT,
  DUPLICATE_TRANSACTION,
  ADMIN_ADD_TRANSACTION,
  ADD_OR_EDIT_TEAM,
  DEFINE_ADMIN_OR_MANAGER,
  ADD_OR_MANAGE_TEAM_LEVEL,
  IMPORT_ACCOUNT_TITLE,
  IMPORT_TRANSACTIONS,
  ACCOUNT_TITLE_LEVEL,
  CONNECT_WITH_API,
  CONNECT_TO_PARTNERS,
  TRANSACTION_DATE,
  IMPREST_PAYMENT
} from "../constants/premiumActions";
import Store from "../configureStore";
import { NEAR_ENDING_PREMIUM, PREMIUM } from "../constants/premiumState";
import {
  premiumBuyPlanByOwnerMessage,
  premiumLastPlanMessage,
  premiumFiniteUpgradePLanByOwnerMessage,
  premiumFiniteUpgradePLanByNonOwnerNonAdminMessage,
  premiumInFiniteUpgradePLanByOwnerMessage,
  premiumFiniteUpgradePLanByAdminMessage,
  premiumInFiniteUpgradePLanByAdminMessage,
  premiumInFiniteUpgradePLanByNonOwnerNonAdminMessage,
  premiumBuyPlanByAdminMessage,
  premiumBuyPlanByNonOwnerNonAdminMessage
} from "../constants/messages";
import { PremiumFeatureAction } from "../actions";
import { getConsumptionObject } from "./consumption";
import { PROJECT_USER_ROLES } from "../constants/projectUser";

const checkIsActiveAdmin = roles => {
  return (
    roles && Array.isArray(roles) && roles.includes(PROJECT_USER_ROLES.ADMIN)
  );
};
const checkIsOwner = roles => {
  return (
    roles && Array.isArray(roles) && roles.includes(PROJECT_USER_ROLES.OWNER)
  );
};
export function checkPremiumFeature(
  action,
  showMessage,
  extraData // {currentImages, ownerId, user_status, user_active_types, premium_state}
) {
  try {
    let init = Store.getState().Init.data,
      init1 = Store.getState().Project;
    const premiumFlags = Store.getState().Init.premium;
    let itemLimit;
    let showPremiumIcon;
    let message, appliedLimits, isWarning, isUpgrade;
    let showMessageFunc, viewOwnerUsers, ownerId;

    //user based premium
    if (action === ADD_PROJECT) {
      {
        /* required data start */
      }
      const loginUser = Store.getState().User.data;
      ownerId = loginUser.id;
      let loginUserPremiumFlags = getConsumptionObject(
        premiumFlags,
        loginUser.id
      );
      const premiumStateForPlanOfLoginUser =
        init && init.premium_state ? init.premium_state : init1.premium_state;
      const planOfLoginUserIsPremium = isPremium(
        premiumStateForPlanOfLoginUser
      );
      let planOfLoginUserIsLastOne = init
        ? init.user_status &&
          init.user_status.plan &&
          init.user_status.plan.is_last
        : init1.user_status &&
          init1.user_status.plan &&
          init1.user_status.plan.is_last;

      {
        /* required data end */
      }

      showPremiumIcon = loginUserPremiumFlags.project_count_remain <= 0;
      itemLimit = loginUserPremiumFlags.project_count_limit;
      showMessageFunc = () =>
        manageAddProject(
          planOfLoginUserIsPremium,
          planOfLoginUserIsLastOne,
          itemLimit
        );
      appliedLimits = ["project_count"];
    } else if (
      //project based premium
      action === SHARE_USER ||
      action === DEFINE_ADMIN_OR_MANAGER ||
      action === ADD_OR_EDIT_TEAM ||
      action === COPY_TRANSACTION
    ) {
      const selectedProjectOwnerId = extraData && extraData.ownerId;
      ownerId = selectedProjectOwnerId;
      const selectedProjectPremiumFlags = getConsumptionObject(
        premiumFlags,
        selectedProjectOwnerId
      );
      const premiumStatForPlanOfSelectedProject =
        extraData && extraData.premium_state;
      const planOfSelectedProjectIsPremium = isPremium(
        premiumStatForPlanOfSelectedProject
      );

      let planOfSelectedProjectIsLastOne =
        extraData && extraData.user_status && extraData.user_status.is_last;

      const loginUserActiveRolesInSelectedProject =
        extraData && extraData.user_active_types;

      let isActiveAdmin = checkIsActiveAdmin(
        loginUserActiveRolesInSelectedProject
      );
      let isOwner = checkIsOwner(loginUserActiveRolesInSelectedProject);

      switch (action) {
        case SHARE_USER:
          showPremiumIcon =
            selectedProjectPremiumFlags &&
            selectedProjectPremiumFlags.user_count_remain <= 0;
          itemLimit =
            selectedProjectPremiumFlags &&
            selectedProjectPremiumFlags.user_count_limit;
          showMessageFunc = () =>
            manageShareUser(
              planOfSelectedProjectIsPremium,
              planOfSelectedProjectIsLastOne,
              isOwner,
              isActiveAdmin,
              itemLimit
            );
          break;
        case DEFINE_ADMIN_OR_MANAGER:
          showPremiumIcon =
            selectedProjectPremiumFlags &&
            selectedProjectPremiumFlags.admin_panel_limit <= 0;
          showMessageFunc = () =>
            manageDefineAdminOrManager(
              planOfSelectedProjectIsPremium,
              isOwner,
              isActiveAdmin
            );
          break;
        case ADD_OR_EDIT_TEAM:
          showPremiumIcon =
            selectedProjectPremiumFlags &&
            selectedProjectPremiumFlags.team_limit <= 0;
          showMessageFunc = () =>
            manageAddOrEditTeam(
              planOfSelectedProjectIsPremium,
              isOwner,
              isActiveAdmin
            );
          break;
        case COPY_TRANSACTION:
          //todo fix premium flags for selected project are not given by farhad : (
          showPremiumIcon =
            selectedProjectPremiumFlags &&
            selectedProjectPremiumFlags.transaction_copy_limit <= 0;
          showMessageFunc = () =>
            manageCopyTransaction(
              planOfSelectedProjectIsPremium,
              isOwner,
              isActiveAdmin
            );
          break;
      }
    } else {
      //current-project based premium
      {
        /* required data start */
      }
      const currentProject = init && init.project;
      const currentProjectOwnerId =
        currentProject && currentProject.owner && currentProject.owner.id;
      ownerId = currentProjectOwnerId;
      const currentProjectPremiumFlags = getConsumptionObject(
        premiumFlags,
        currentProjectOwnerId
      );
      const premiumStatForPlanOfCurrentProject =
        currentProject && currentProject.premium_state;
      const planOfCurrentProjectIsPremium = isPremium(
        premiumStatForPlanOfCurrentProject
      );
      let planOfCurrentProjectIsLastOne =
        currentProject &&
        currentProject.user_status &&
        currentProject.user_status.is_last;
      const loginUserActiveRolesInCurrentProject =
        init && init.user_active_types;

      let isActiveAdmin = checkIsActiveAdmin(
        loginUserActiveRolesInCurrentProject
      );
      let isOwner = checkIsOwner(loginUserActiveRolesInCurrentProject);
      {
        /* required data end */
      }
      switch (action) {
        case ADD_TRANSACTION:
          showPremiumIcon =
            currentProjectPremiumFlags.transaction_count_remain <= 0;
          itemLimit = currentProjectPremiumFlags.transaction_count_limit;
          showMessageFunc = () =>
            manageAddTransaction(
              planOfCurrentProjectIsPremium,
              planOfCurrentProjectIsLastOne,
              isOwner,
              isActiveAdmin,
              itemLimit
            );
          break;
        case ADD_IMAGE_TO_TRANSACTION:
          const transactionLimit =
            currentProjectPremiumFlags.transaction_image_count_limit;
          showPremiumIcon =
            currentProjectPremiumFlags.image_count_remain <= 0 ||
            transactionLimit <= extraData.currentImages;
          itemLimit = currentProjectPremiumFlags.image_count_limit;
          const itemRemain = currentProjectPremiumFlags.image_count_remain;
          showMessageFunc = () =>
            manageAddImages(
              planOfCurrentProjectIsPremium,
              planOfCurrentProjectIsLastOne,
              isOwner,
              isActiveAdmin,
              itemLimit,
              itemRemain,
              transactionLimit,
              extraData.currentImages
            );
          break;
        case ADD_PETTY_CASH:
          showPremiumIcon =
            currentProjectPremiumFlags.imprest_count_remain <= 0;
          itemLimit = currentProjectPremiumFlags.imprest_count_limit;
          showMessageFunc = () =>
            manageAddPettyCash(
              planOfCurrentProjectIsPremium,
              planOfCurrentProjectIsLastOne,
              isOwner,
              isActiveAdmin,
              itemLimit
            );
          break;
        case GET_PDF:
          showPremiumIcon = currentProjectPremiumFlags.pdf_count_remain <= 0;
          itemLimit = currentProjectPremiumFlags.pdf_count_limit;
          showMessageFunc = () =>
            manageGetPdf(
              planOfCurrentProjectIsPremium,
              planOfCurrentProjectIsLastOne,
              isOwner,
              isActiveAdmin,
              itemLimit
            );
          break;
        case GET_EXCEL:
          showPremiumIcon = currentProjectPremiumFlags.excel_count_limit <= 0;
          showMessageFunc = () =>
            manageGetExcel(
              planOfCurrentProjectIsPremium,
              isOwner,
              isActiveAdmin
            );
          break;
        case GET_ACCOUNTANT:
          showPremiumIcon =
            currentProjectPremiumFlags.accountant_report_limit <= 0;
          showMessageFunc = () =>
            manageGetAccountantFile(
              planOfCurrentProjectIsPremium,
              isOwner,
              isActiveAdmin
            );
          break;
        case HASHTAG_REPORT:
          showPremiumIcon =
            currentProjectPremiumFlags.hashtag_report_limit <= 0;
          showMessageFunc = () =>
            manageHashtagReport(
              planOfCurrentProjectIsPremium,
              isOwner,
              isActiveAdmin
            );
          break;
        case MONTHLY_REPORT:
          showPremiumIcon =
            currentProjectPremiumFlags.monthly_report_limit <= 0;
          showMessageFunc = () =>
            manageMonthlyReport(
              planOfCurrentProjectIsPremium,
              isOwner,
              isActiveAdmin
            );
          break;
        case CONTACT_REPORT:
          showPremiumIcon =
            currentProjectPremiumFlags.contact_report_limit <= 0;
          showMessageFunc = () =>
            manageContactReport(
              planOfCurrentProjectIsPremium,
              isOwner,
              isActiveAdmin
            );
          break;
        // admin_transaction_limit
        case ADD_MONTHLY_BUDGET:
          showPremiumIcon =
            currentProjectPremiumFlags.monthly_budget_limit <= 0;
          showMessageFunc = () =>
            manageAddMonthlyBudget(
              planOfCurrentProjectIsPremium,
              isOwner,
              isActiveAdmin
            );
          break;
        case ADD_PETTY_CASH_BUDGET:
          showPremiumIcon =
            currentProjectPremiumFlags.imprest_budget_limit <= 0;
          showMessageFunc = () =>
            manageAddPettyCashBudget(
              planOfCurrentProjectIsPremium,
              isOwner,
              isActiveAdmin
            );
          break;
        case PRINT_SUMMARY_PAYMENT_RECEIVE:
          showPremiumIcon =
            currentProjectPremiumFlags.transaction_print_limit <= 0;
          showMessageFunc = () =>
            managePrintPaymentReceive(
              planOfCurrentProjectIsPremium,
              isOwner,
              isActiveAdmin
            );
          break;

        case DUPLICATE_TRANSACTION:
          showPremiumIcon =
            currentProjectPremiumFlags.transaction_duplicate_limit <= 0;
          showMessageFunc = () =>
            manageDuplicateTransaction(
              planOfCurrentProjectIsPremium,
              isOwner,
              isActiveAdmin
            );
          break;
        case ADMIN_ADD_TRANSACTION:
          showPremiumIcon =
            currentProjectPremiumFlags.admin_transaction_limit <= 0;
          showMessageFunc = () =>
            manageAdminAddTransaction(
              planOfCurrentProjectIsPremium,
              isOwner,
              isActiveAdmin
            );
          break;
        case ADD_OR_MANAGE_TEAM_LEVEL:
          showPremiumIcon = currentProjectPremiumFlags.team_level_limit <= 0;
          showMessageFunc = () =>
            manageAddOrManageTeamLevel(
              planOfCurrentProjectIsPremium,
              isOwner,
              isActiveAdmin
            );
          break;
        case IMPORT_ACCOUNT_TITLE:
          showPremiumIcon =
            currentProjectPremiumFlags.account_title_import_limit <= 0;
          showMessageFunc = () =>
            manageImportAccountTitle(
              planOfCurrentProjectIsPremium,
              isOwner,
              isActiveAdmin
            );
          break;
        case IMPORT_TRANSACTIONS:
          showPremiumIcon =
            currentProjectPremiumFlags.transaction_import_limit <= 0;
          showMessageFunc = () =>
            manageImportTransactions(
              planOfCurrentProjectIsPremium,
              isOwner,
              isActiveAdmin
            );
          break;
        case ACCOUNT_TITLE_LEVEL:
          showPremiumIcon =
            currentProjectPremiumFlags.account_title_level_limit <= 0;
          showMessageFunc = () =>
            manageAccountTitleLevel(
              planOfCurrentProjectIsPremium,
              isOwner,
              isActiveAdmin
            );
          break;
        case CONNECT_WITH_API:
          showPremiumIcon =
            currentProjectPremiumFlags.connect_with_api_limit <= 0;
          showMessageFunc = () =>
            manageConnectWithApi(
              planOfCurrentProjectIsPremium,
              isOwner,
              isActiveAdmin
            );
          break;
        case CONNECT_TO_PARTNERS:
          showPremiumIcon =
            currentProjectPremiumFlags.connect_to_partners_limit <= 0;
          showMessageFunc = () =>
            manageConnectToPartners(
              planOfCurrentProjectIsPremium,
              isOwner,
              isActiveAdmin
            );
          break;
        case TRANSACTION_DATE:
          showPremiumIcon =
            currentProjectPremiumFlags.transaction_date_limit <= 0;
          showMessageFunc = () =>
            manageTransactionDate(
              planOfCurrentProjectIsPremium,
              isOwner,
              isActiveAdmin
            );
          break;
        case IMPREST_PAYMENT:
          showPremiumIcon =
            currentProjectPremiumFlags.imprest_payment_limit <= 0;
          showMessageFunc = () =>
            manageImprestPayment(
              planOfCurrentProjectIsPremium,
              isOwner,
              isActiveAdmin
            );
          break;
      }
    }
    const accessIsDenied = showPremiumIcon;
    if (accessIsDenied && showMessage) {
      [message, isWarning, isUpgrade, viewOwnerUsers] = showMessageFunc();
      Store.dispatch(
        PremiumFeatureAction.modalData({
          message,
          isWarning,
          isUpgrade,
          viewOwnerUsers,
          ownerId,
          appliedLimits
        })
      );
    }
    return accessIsDenied;
  } catch (e) {
    console.log(e);
  }
}

export const isPremium = state => {
  return state === PREMIUM || state === NEAR_ENDING_PREMIUM;
};

function manageShareUser(
  isPremiumPlan,
  isLastPlan,
  isOwner,
  isActiveAdmin,
  usersLimit
) {
  let message,
    isWarning = false,
    isUpgrade = false,
    viewOwnerUsers = false;
  const text1 = `شرکت‌ها‌ را با ${usersLimit} کاربر اشتراک‌گذاری`;
  const text2 = "اشتراک‌گذاری با کاربران بیشتر";
  const text3 = "امکان اشتراک‌گذاری شرکت‌ها";
  const text4 = "دعوت کاربر جدید به این شرکت";
  if (isPremiumPlan) {
    if (isLastPlan) {
      message = premiumLastPlanMessage(undefined, text1);
      isWarning = true;
    } else {
      if (isOwner) {
        message = premiumFiniteUpgradePLanByOwnerMessage(
          undefined,
          text1,
          text2
        );
        isUpgrade = true;
      } else if (isActiveAdmin) {
        message = premiumFiniteUpgradePLanByAdminMessage(
          undefined,
          text1,
          text2
        );
        isUpgrade = true;
        viewOwnerUsers = true;
      } else {
        // U can't change baby
        message = premiumFiniteUpgradePLanByNonOwnerNonAdminMessage(
          undefined,
          text1,
          text2
        );
        isWarning = true;
      }
    }
  } else {
    if (isOwner) {
      message = premiumBuyPlanByOwnerMessage(text3);
    } else if (isActiveAdmin) {
      message = premiumBuyPlanByAdminMessage(text3);
      viewOwnerUsers = true;
    } else {
      message = premiumBuyPlanByNonOwnerNonAdminMessage(text4);
      isWarning = true;
    }
  }
  return [message, isWarning, isUpgrade, viewOwnerUsers];
}
function manageAddProject(isUserPremium, isLastPlan, projectLimit) {
  let message = "",
    isWarning = false,
    isUpgrade = false;
  if (isUserPremium) {
    if (isLastPlan) {
      message = premiumLastPlanMessage(projectLimit, "شرکت ایجاد");
      isWarning = true;
    } else {
      message = premiumFiniteUpgradePLanByOwnerMessage(
        projectLimit,
        "شرکت ایجاد",
        "ایجاد شرکت‌های بیشتر"
      );
      isUpgrade = true;
    }
  } else {
    message = premiumBuyPlanByOwnerMessage("ایجاد شرکت‌های بیشتر");
  }
  return [message, isWarning, isUpgrade];
}

function manageAddTransaction(
  isPremiumPlan,
  isLastPlan,
  isOwner,
  isActiveAdmin,
  transactionsLimit
) {
  return manageGeneralFinitePremiumFeature(
    isPremiumPlan,
    isLastPlan,
    isOwner,
    isActiveAdmin,
    transactionsLimit,
    "پرداخت و دریافت ثبت",
    "ثبت پرداخت و دریافت‌های بیشتر",
    "امکان ثبت نامحدود پرداخت و دریافت"
  );
}

function manageAddImages(
  isPremiumPlan,
  isLastPlan,
  isOwner,
  isActiveAdmin,
  imagesLimit,
  imagesRemain,
  transactionLimit,
  currentImages
) {
  let message = "",
    isWarning = false,
    isUpgrade = false;
  if (transactionLimit <= currentImages) {
    return manageGeneralFinitePremiumFeature(
      isPremiumPlan,
      isLastPlan,
      isOwner,
      isActiveAdmin,
      transactionLimit,
      "عکس به هر پرداخت یا دریافت پیوست",
      "پیوست عکس‌های بیشتر به هر پرداخت یا دریافت",
      "امکان پیوست عکس‌های بیشتر به هر پرداخت و دریافت"
    );
  } else if (imagesRemain <= 0) {
    return manageGeneralFinitePremiumFeature(
      isPremiumPlan,
      isLastPlan,
      isOwner,
      isActiveAdmin,
      imagesLimit,
      "عکس به پرداخت یا دریافت‌ها پیوست",
      "پیوست عکس‌های بیشتر",
      "امکان پیوست عکس‌های بیشتر به پرداخت و دریافت‌ها"
    );
  }
  return [message, isWarning, isUpgrade];
}

function manageAddPettyCash(
  isPremiumPlan,
  isLastPlan,
  isOwner,
  isActiveAdmin,
  pettyCashLimit
) {
  return manageGeneralFinitePremiumFeature(
    isPremiumPlan,
    isLastPlan,
    isOwner,
    isActiveAdmin,
    pettyCashLimit,
    "گزارش تنخواه ایجاد",
    "ایجاد گزارش تنخواه بیشتر",
    "امکان ایجاد نامحدود گزارش تنخواه"
  );
}

function manageGetPdf(
  isPremiumPlan,
  isLastPlan,
  isOwner,
  isActiveAdmin,
  pdfLimit
) {
  return manageGeneralFinitePremiumFeature(
    isPremiumPlan,
    isLastPlan,
    isOwner,
    isActiveAdmin,
    pdfLimit,
    "فایل PDF در روز دریافت",
    "دریافت فایل PDF بیشتر در روز",
    "امکان دریافت فایل PDF به صورت نامحدود"
  );
}

function manageGetExcel(isPremiumPlan, isOwner, isActiveAdmin) {
  return manageGeneralInfinitePremiumFeature(
    isPremiumPlan,
    isOwner,
    isActiveAdmin,
    "دریافت فایل Excel",
    "امکان دریافت فایل Excel به صورت نامحدود"
  );
}

function manageGetAccountantFile(isPremiumPlan, isOwner, isActiveAdmin) {
  return manageGeneralInfinitePremiumFeature(
    isPremiumPlan,
    isOwner,
    isActiveAdmin,
    "دریافت فایل سند حسابداری",
    "امکان دریافت فایل سند حسابداری به صورت نامحدود"
  );
}

// function manageGetBackup(isPremiumPlan, isOwner, isActiveAdmin) {
//   return manageGeneralInfinitePremiumFeature(
//     isPremiumPlan,
//     isOwner,
//     isActiveAdmin,
//     "دریافت فایل پشتیبان",
//     "امکان دریافت فایل پشتیبان"
//   );
// }

function manageHashtagReport(isPremiumPlan, isOwner, isActiveAdmin) {
  return manageGeneralInfinitePremiumFeature(
    isPremiumPlan,
    isOwner,
    isActiveAdmin,
    "مشاهده گزارش هشتگ‌ها",
    "امکان مشاهده گزارش هشتگ‌ها"
  );
}

function manageMonthlyReport(isPremiumPlan, isOwner, isActiveAdmin) {
  return manageGeneralInfinitePremiumFeature(
    isPremiumPlan,
    isOwner,
    isActiveAdmin,
    "مشاهده گزارش ماهانه",
    "امکان مشاهده گزارش ماهانه"
  );
}

function manageContactReport(isPremiumPlan, isOwner, isActiveAdmin) {
  return manageGeneralInfinitePremiumFeature(
    isPremiumPlan,
    isOwner,
    isActiveAdmin,
    "مشاهده گزارش طرف حساب‌ها",
    "امکان مشاهده گزارش طرف حساب‌ها"
  );
}

function manageAddMonthlyBudget(isPremiumPlan, isOwner, isActiveAdmin) {
  return manageGeneralInfinitePremiumFeature(
    isPremiumPlan,
    isOwner,
    isActiveAdmin,
    "افزودن بودجه ماهانه",
    "امکان افزودن بودجه ماهانه"
  );
}

function manageAddPettyCashBudget(isPremiumPlan, isOwner, isActiveAdmin) {
  return manageGeneralInfinitePremiumFeature(
    isPremiumPlan,
    isOwner,
    isActiveAdmin,
    "تعریف بودجه تنخواه",
    "امکان تعریف بودجه تنخواه"
  );
}

function managePrintPaymentReceive(isPremiumPlan, isOwner, isActiveAdmin) {
  return manageGeneralInfinitePremiumFeature(
    isPremiumPlan,
    isOwner,
    isActiveAdmin,
    "چاپ اسناد پرداخت و دریافت",
    "امکان چاپ اسناد پرداخت و دریافت"
  );
}

function manageCopyTransaction(isPremiumPlan, isOwner, isActiveAdmin) {
  return manageGeneralInfinitePremiumFeature(
    isPremiumPlan,
    isOwner,
    isActiveAdmin,
    "کپی تراکنش بین شرکت‌ها",
    "امکان کپی تراکنش بین شرکت‌ها",
    "امکان کپی تراکنش بین شرکت‌ها",
    "کپی تراکنش‌های انتخابی به این شرکت"
  );
}

function manageDuplicateTransaction(isPremiumPlan, isOwner, isActiveAdmin) {
  return manageGeneralInfinitePremiumFeature(
    isPremiumPlan,
    isOwner,
    isActiveAdmin,
    "تکرار تراکنش",
    "امکان تکرار تراکنش"
  );
}

function manageAdminAddTransaction(isPremiumPlan, isOwner, isActiveAdmin) {
  return manageGeneralInfinitePremiumFeature(
    isPremiumPlan,
    isOwner,
    isActiveAdmin,
    "ثبت پرداخت و دریافت در پنل مدیریت",
    "ثبت پرداخت و دریافت در پنل مدیریت"
  );
}

function manageAddOrEditTeam(isPremiumPlan, isOwner, isActiveAdmin) {
  return manageGeneralInfinitePremiumFeature(
    isPremiumPlan,
    isOwner,
    isActiveAdmin,
    "ایجاد و ویرایش تیم تنخواه‌داری و مدیریت اطلاعات پایه بر اساس تیم‌های تنخواه‌داری",
    "ایجاد و ویرایش تیم تنخواه‌داری و مدیریت اطلاعات پایه بر اساس تیم‌های تنخواه‌داری"
  );
}

function manageDefineAdminOrManager(isPremiumPlan, isOwner, isActiveAdmin) {
  return manageGeneralInfinitePremiumFeature(
    isPremiumPlan,
    isOwner,
    isActiveAdmin,
    "تعریف ادمین و مدیر برای شرکت",
    "تعریف ادمین و مدیر برای شرکت",
    " تعریف ادمین و مدیر برای شرکت",
    "تعریف ادمین و مدیر برای شرکت"
  );
}

function manageAddOrManageTeamLevel(isPremiumPlan, isOwner, isActiveAdmin) {
  return manageGeneralInfinitePremiumFeature(
    isPremiumPlan,
    isOwner,
    isActiveAdmin,
    "تعریف و مدیریت سطح تایید گزارش‌های تنخواه",
    "تعریف و مدیریت سطح تایید گزارش‌های تنخواه"
  );
}

function manageImportAccountTitle(isPremiumPlan, isOwner, isActiveAdmin) {
  return manageGeneralInfinitePremiumFeature(
    isPremiumPlan,
    isOwner,
    isActiveAdmin,
    "بارگذاری سرفصل‌حساب‌ها از اکسل",
    "بارگذاری سرفصل‌حساب‌ها از اکسل"
  );
}

function manageImportTransactions(isPremiumPlan, isOwner, isActiveAdmin) {
  return manageGeneralInfinitePremiumFeature(
    isPremiumPlan,
    isOwner,
    isActiveAdmin,
    "بارگذاری تراکنش از اکسل",
    "بارگذاری تراکنش از اکسل"
  );
}

function manageAccountTitleLevel(isPremiumPlan, isOwner, isActiveAdmin) {
  return manageGeneralInfinitePremiumFeature(
    isPremiumPlan,
    isOwner,
    isActiveAdmin,
    "تعریف و مدیریت زیر سرفصل‌حساب",
    "تعریف و مدیریت زیر سرفصل‌حساب"
  );
}

function manageConnectWithApi(isPremiumPlan, isOwner, isActiveAdmin) {
  return manageGeneralInfinitePremiumFeature(
    isPremiumPlan,
    isOwner,
    isActiveAdmin,
    "تنظیمات اتصال به API",
    "تنظیمات اتصال به API"
  );
}

function manageConnectToPartners(isPremiumPlan, isOwner, isActiveAdmin) {
  return manageGeneralInfinitePremiumFeature(
    isPremiumPlan,
    isOwner,
    isActiveAdmin,
    "تنظیمات اتصال به نرم‌افزار همکار",
    "تنظیمات اتصال به نرم‌افزار همکار"
  );
}

function manageTransactionDate(isPremiumPlan, isOwner, isActiveAdmin) {
  return manageGeneralInfinitePremiumFeature(
    isPremiumPlan,
    isOwner,
    isActiveAdmin,
    "محدود کردن تاریخ تراکنش‌ها",
    "محدود کردن تاریخ تراکنش‌ها"
  );
}

function manageImprestPayment(isPremiumPlan, isOwner, isActiveAdmin) {
  return manageGeneralInfinitePremiumFeature(
    isPremiumPlan,
    isOwner,
    isActiveAdmin,
    "تعیین سقف جمع پرداختی‌های گزارش‌های تنخواه",
    "تعیین سقف جمع پرداختی‌های گزارش‌های تنخواه"
  );
}

function manageGeneralFinitePremiumFeature(
  isPremiumPlan,
  isLastPlan,
  isOwner,
  isActiveAdmin,
  itemLimit,
  text1,
  text2,
  text3
) {
  let message = "",
    isWarning = false,
    isUpgrade = false;
  if (isPremiumPlan) {
    // if (isLastPlan) {
    //   message = premiumLastPlanMessage(itemLimit, text1);
    //   isWarning = true;
    // } else {
    if (isOwner || isActiveAdmin) {
      if (isLastPlan) {
        message = premiumLastPlanMessage(itemLimit, text1);
        isWarning = true;
      } else {
        if (isOwner) {
          message = premiumFiniteUpgradePLanByOwnerMessage(
            itemLimit,
            text1,
            text2
          );
          isUpgrade = true;
        } else if (isActiveAdmin) {
          message = premiumFiniteUpgradePLanByAdminMessage(
            itemLimit,
            text1,
            text2
          );
          isUpgrade = true;
        }
      }
    } else {
      message = premiumFiniteUpgradePLanByNonOwnerNonAdminMessage(
        itemLimit,
        text1,
        text2
      );
      isWarning = true;
    }
    // if (isOwner) {
    //   message = premiumFiniteUpgradePLanByOwnerMessage(
    //     itemLimit,
    //     text1,
    //     text2
    //   );
    //   isUpgrade = true;
    // } else if (isActiveAdmin) {
    //   message = premiumFiniteUpgradePLanByAdminMessage(
    //     itemLimit,
    //     text1,
    //     text2
    //   );
    //   isUpgrade = true;
    // } else {
    //   message = premiumFiniteUpgradePLanByNonOwnerNonAdminMessage(
    //     itemLimit,
    //     text1,
    //     text2
    //   );
    //   isWarning = true;
    // }
    // }
  } else {
    message = premiumBuyPlanByOwnerMessage(text3);
  }
  return [message, isWarning, isUpgrade];
}

function manageGeneralInfinitePremiumFeature(
  isPremiumPlan,
  isOwner,
  isActiveAdmin,
  text1,
  text2,
  text3,
  text4
) {
  let message = "",
    isWarning = false,
    isUpgrade = false;
  if (isPremiumPlan) {
    if (isOwner) {
      message = premiumInFiniteUpgradePLanByOwnerMessage(text1);
      isUpgrade = true;
    } else if (isActiveAdmin) {
      message = premiumInFiniteUpgradePLanByAdminMessage(text1);
      isUpgrade = true;
    } else {
      message = premiumInFiniteUpgradePLanByNonOwnerNonAdminMessage(text1);
      isWarning = true;
    }
  } else {
    if (isOwner) {
      message = premiumBuyPlanByOwnerMessage(text2);
    } else if (isActiveAdmin) {
      message = premiumBuyPlanByAdminMessage(text3);
    } else {
      message = premiumBuyPlanByNonOwnerNonAdminMessage(text4);
      isWarning = true;
    }
  }
  return [message, isWarning, isUpgrade];
}

export const checkPermissionHandleClick = (callback, action) => {
  const showPremiumMessage = checkPremiumFeature(action, true);
  if (!showPremiumMessage) {
    callback();
  }
};
